import { useContainerMediaQuery } from '@infl-ts/util-block-width-context';
import { Box, Divider, Skeleton } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var SingleBadgeLoader = function SingleBadgeLoader(_ref) {
  var width = _ref.width;
  return /*#__PURE__*/_jsx(Skeleton, {
    sx: {
      mr: 2,
      borderBottomLeftRadius: '40px',
      borderBottomRightRadius: '40px'
    },
    width: width,
    height: "100%",
    variant: "rectangular",
    "data-element": "Skeleton",
    "data-component": "SingleBadgeLoader",
    "data-source-file": "badges-loader.tsx"
  });
};

var SingleLevelLoader = function SingleLevelLoader() {
  var isMobile = useContainerMediaQuery({
    maxWidth: 'sm'
  });
  var badgeDimension = isMobile ? 40 : 64;
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      my: 2,
      display: 'flex',
      flexDirection: 'column'
    },
    "data-element": "Box",
    "data-component": "SingleLevelLoader",
    "data-source-file": "badges-loader.tsx",
    children: [/*#__PURE__*/_jsx(Skeleton, {
      width: 140,
      "data-element": "Skeleton",
      "data-component": "SingleLevelLoader",
      "data-source-file": "badges-loader.tsx"
    }), /*#__PURE__*/_jsxs(Box, {
      sx: {
        mt: 1,
        mb: 2,
        display: 'flex',
        height: badgeDimension,
        overflow: 'hidden',
        flexWrap: 'wrap'
      },
      "data-element": "Box",
      "data-source-file": "badges-loader.tsx",
      children: [/*#__PURE__*/_jsx(SingleBadgeLoader, {
        width: badgeDimension,
        "data-element": "SingleBadgeLoader",
        "data-source-file": "badges-loader.tsx"
      }), /*#__PURE__*/_jsx(SingleBadgeLoader, {
        width: badgeDimension,
        "data-element": "SingleBadgeLoader",
        "data-source-file": "badges-loader.tsx"
      }), /*#__PURE__*/_jsx(SingleBadgeLoader, {
        width: badgeDimension,
        "data-element": "SingleBadgeLoader",
        "data-source-file": "badges-loader.tsx"
      }), /*#__PURE__*/_jsx(SingleBadgeLoader, {
        width: badgeDimension,
        "data-element": "SingleBadgeLoader",
        "data-source-file": "badges-loader.tsx"
      }), /*#__PURE__*/_jsx(SingleBadgeLoader, {
        width: badgeDimension,
        "data-element": "SingleBadgeLoader",
        "data-source-file": "badges-loader.tsx"
      })]
    })]
  });
};

var BadgesLoader = function BadgesLoader() {
  return /*#__PURE__*/_jsxs(Box, {
    "data-element": "Box",
    "data-component": "BadgesLoader",
    "data-source-file": "badges-loader.tsx",
    children: [/*#__PURE__*/_jsx(SingleLevelLoader, {
      "data-element": "SingleLevelLoader",
      "data-component": "BadgesLoader",
      "data-source-file": "badges-loader.tsx"
    }), /*#__PURE__*/_jsx(SingleLevelLoader, {
      "data-element": "SingleLevelLoader",
      "data-source-file": "badges-loader.tsx"
    }), /*#__PURE__*/_jsx(Divider, {
      sx: {
        my: 3
      },
      "data-element": "Divider",
      "data-source-file": "badges-loader.tsx"
    }), /*#__PURE__*/_jsx(SingleLevelLoader, {
      "data-element": "SingleLevelLoader",
      "data-source-file": "badges-loader.tsx"
    })]
  });
};

export default BadgesLoader;